<template lang="pug">
div
  el-card(shadow='hover').card-collapse
    app-header-dados-processo(
      :processo="processo",
      :isCCR="false"
      :dadosCadastros="dadosCadastros"
    )
  el-card(shadow="hover").card-container
    div
      el-steps.card-container(:active='active', finish-status='success', simple)
        el-step(title='Confirmar dados da VTN')

      validation-observer(ref='validation' tag='div', v-if="active === 0")
      div(v-if="active === 0")
        visualizarVtnRR(
          v-if="dadosVtn",
          :vtn="dadosVtn",
          :processo="processo",
          :isUsuarioExterno="false",
          :isVisualizar="visualizar"
        )
      app-buttons-cadastro(
        :isPrimeiroPasso="true"
        :showButtonCancelar="true",
        :isUltimoPasso="true",
        @cancelar='cancelar',
        @finalizar='finalizar'
      )
</template>

<script>
import { mapActions } from 'vuex'
import AppHeaderDadosProcesso from '@/components/AppHeaderDadosProcesso.vue'
import AppButtonsCadastro from '@/components/AppButtonsCadastro.vue'
import AppNotificacao from '@/components/mixins/AppNotificacao.vue'
import VisualizarVtnRR from '@/screens/analise/vtn/VisualizarVtnRR.vue'

export default {
  components: {
    AppHeaderDadosProcesso,
    AppButtonsCadastro,
    VisualizarVtnRR
  },

  mixins: [AppNotificacao],

  props: {
    processo: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      active: 0,
      dadosCadastros: {
        despacho: {
          id: '0'
        }
      },
      vtnRequest: null,
      boleto: '',
      parcelas: [],
      dadosVtn: null,
      visualizar: true
    }
  },

  computed: {
    isPrimeiroPasso () {
      return this.active === 0
    },

    isUltimoPasso () {
      return this.active === 1
    }
  },

  async created () {
    const processo = await this.getProcesso(this.processo.numeroProtocolo)
    this.dadosVtn = await this.getVtnByIdProcesso(processo.id)
  },

  methods: {
    ...mapActions({
      getProcesso: 'processos/getProcessoByProtocolo',
      getVtnByIdProcesso: 'vtn/getVtnbyIdProcesso',
      updateVtn: 'vtn/updateVtn',
      uploadBoleto: 'vtn/salvarBoleto',
      updateParcelas: 'vtn/updateParcelas',
      tramitar: 'processo/tramitar'
    }),

    async finalizar () {
      await this.tramitar(this.processo).then(response => {
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          this.$messages.PROCESSOS_ENCAMINHADOS
        )
        this.$router.push({
          name: 'AGUARDANDO_VALIDACAO_ANALISE'
        })
      }).catch(e => console.error(e))
    },

    cancelar () {
      this.$router.push({
        name: 'AGUARDANDO_VALIDACAO_ANALISE'
      })
    },

    mensagemDarEmitido () {
      return 'Pagamento acusado.'
    },

    salvarBoleto (file) {
      this.boleto = file
    },

    atualizaNumeroDar (numeroDar) {
      this.boletoDTO.numeroDar = numeroDar
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/ConferirVTN.vue